export class User {
    get id() {
        return this.userState.id;
    }
    get photo() {
        return this.userState.photo;
    }
    get sign() {
        return this.userState.sign;
    }
    get access_token() {
        return this.userState.access_token;
    }
    get status() {
        return this.userState.status;
    }
    get enabled() {
        return this.userState.enabled;
    }
    get removed() {
        return this.userState.removed;
    }
    get type() {
        return this.userState.type;
    }
    // get rol_name(): string {
    //     return this.userState.rol_name;
    // }
    get name() {
        return this.userState.name;
    }
    get surname1() {
        return this.userState.surname1;
    }
    get surname2() {
        return this.userState.surname2;
    }
    get dni() {
        return this.userState.dni;
    }
    get position_id() {
        return this.userState.position_id;
    }
    get agent_id() {
        return this.userState.agent_id;
    }
    get municipality_id() {
        return this.userState.municipality_id;
    }
    get is_agent() {
        return this.userState.is_agent;
    }
    get phone() {
        return this.userState.phone;
    }
    get email() {
        return this.userState.email;
    }
    get password() {
        return this.userState.password;
    }
    get image() {
        return this.userState.image;
    }
    get date_created() {
        return this.userState.date_created;
    }
    get date_updated() {
        return this.userState.date_updated;
    }
    get date_last_login() {
        return this.userState.date_last_login;
    }
    get date_removed() {
        return this.userState.date_removed;
    }
    get signer() {
        return this.userState.signer;
    }
    get cargo() {
        return this.userState.cargo;
    }
    set photo(photo) {
        this.userState.photo = photo;
    }
    set name(name) {
        this.userState.name = name;
    }
    set surname1(surname1) {
        this.userState.surname1 = surname1;
    }
    set surname2(surname2) {
        this.userState.surname2 = surname2;
    }
    set dni(dni) {
        this.userState.dni = dni;
    }
    set position_id(position_id) {
        this.userState.position_id = position_id;
    }
    set agent_id(agent_id) {
        this.userState.agent_id = agent_id;
    }
    set municipality_id(municipality_id) {
        this.userState.municipality_id = municipality_id;
    }
    set is_agent(is_agent) {
        this.userState.is_agent = is_agent;
    }
    set enabled(enabled) {
        this.userState.enabled = enabled;
    }
    set phone(phone) {
        this.userState.phone = phone;
    }
    set email(email) {
        this.userState.email = email;
    }
    set password(password) {
        this.userState.password = password;
    }
    set image(image) {
        this.userState.image = image;
    }
    set sign(sign) {
        this.userState.sign = sign;
    }
    set type(type) {
        this.userState.type = type;
    }
    set signer(signer) {
        this.userState.signer = signer;
    }
    set cargo(cargo) {
        this.userState.cargo = cargo;
    }
    constructor(userState) {
        this.userState = userState;
    }
    getState() {
        return this.userState;
    }
}
